import PropTypes from 'prop-types';

export const ModelInterviewType = PropTypes.shape({
	id:          PropTypes.string,
	title:       PropTypes.string,
	description: PropTypes.string,
	preview:     PropTypes.string,
	duration:    PropTypes.string,
	videoUrl:    PropTypes.string,
	vip:         PropTypes.bool,
	ageRating:   PropTypes.number,
	model:       PropTypes.shape({
		id:     PropTypes.number,
		name:   PropTypes.string,
		linkVX: PropTypes.string,
	}),
	restriction: PropTypes.shape({
		restricted: PropTypes.bool,
		reasons:    PropTypes.arrayOf(PropTypes.string),
	}),
});